import React, { Component } from 'react';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import TextField from 'material-ui/TextField';
import _ from 'lodash';

import {
  fetchHistory,
  updateStatAttribute,
  updateQuiz,
  setCurrent,
  updateNotesFlagged
} from '../actions/index';
import { HELPERS } from '../config/constants';

import '../styles/NotesEditor.css';

const focusNotes = textArea => (textArea ? textArea.focus() : null);

class NotesEditor extends Component {
  constructor(props) {
    super(props);

    this.state = {
      displaySaveNotification: false
    };

    this.saveNotes = _.debounce(this.saveNotes.bind(this), 1000);
  }

  componentWillReceiveProps() {
    this.props.setCurrent();
  }

  onChange(notes) {
    const { updateQuiz, currentQuestionIndex } = this.props;

    this.saveNotes(notes);
    updateQuiz(
      HELPERS.UPDATE_OBJECT(
        { currentNotesValue: notes, notes },
        currentQuestionIndex
      )
    );
  }

  saveNotes(notes) {
    const {
      fetchHistory,
      updateStatAttribute,
      question,
      updateNotesFlagged
    } = this.props;

    updateStatAttribute({ notes }).then(() => {
      fetchHistory();
      updateNotesFlagged(question, true, notes);
      this.setState({ displaySaveNotification: true }, () =>
        window.setTimeout(
          () => this.setState({ displaySaveNotification: false }),
          1000
        )
      );
    });
  }

  render() {
    const { editingNotes, currentNotesValue, notes } = this.props;

    return (
      <div className="notes-section">
        <p
          style={{ opacity: this.state.displaySaveNotification ? 100 : 0 }}
          className="save-notification"
        >
          Notes Saved
        </p>
        {editingNotes ? (
          <TextField
            className="notes-editor"
            value={currentNotesValue || notes || ''}
            multiLine
            rowsMax={5}
            onChange={(e, val) => this.onChange(val)}
            ref={focusNotes}
            underlineFocusStyle={{ borderBottomColor: '#444' }}
            floatingLabelFocusStyle={{ color: '#444' }}
          />
        ) : null}
      </div>
    );
  }
}

// NotesEditor.propTypes = {
//   signInHandler: React.PropTypes.func.isRequired,
//   signIn: React.PropTypes.func.isRequired,
// };

function mapStateToProps(state) {
  const question = state.quiz.questions[state.quiz.currentQuestionIndex];

  return {
    question,
    editingNotes: question ? question.editingNotes : null,
    currentQuestionIndex: state.quiz.currentQuestionIndex,
    currentNotesValue: question ? question.currentNotesValue : null,
    notes: question ? question.notes : null
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      fetchHistory,
      updateStatAttribute,
      updateQuiz,
      setCurrent,
      updateNotesFlagged
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(NotesEditor);



// WEBPACK FOOTER //
// ./src/containers/NotesEditor.js